import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Box,
  Typography,
} from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import UndoIcon from '@mui/icons-material/Undo';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import addCommas from '../../utils/functions/commas';
import dayjs from 'dayjs';

function ReverseDialog({
  t,
  open,
  onClose,
  onConfirm,
  reason,
  setReason,
  touched,
  selectedTransRef,
  type,
}) {
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          onClose(event, reason);
        }
      }}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2,
          boxShadow: 10,
        },
      }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <HistoryIcon sx={{ color: 'error.main', fontSize: 32 }} />
          <Typography variant="h6" fontWeight="bold">
            {t('app.reversalDetail')}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pb: 1, px: 3, pt: 2 }}>
        <Box display="flex" alignItems="center" mb={2}>
          <Typography variant="body1" color="text.primary" fontWeight="bold">
        {type === 'Approved' && t('app.revertApprovedToPending')}
        {type === 'Rejected' && t('app.revertRejectedToPending')}
          </Typography>
        </Box>

        <Box
          display="flex"
          flexDirection="column"
          gap={1}
          p={2}
          mb={2}
          sx={{
            backgroundColor: '#f5f5f5',
            borderRadius: 2,
            border: '1px solid #e0e0e0',
          }}
        >
          <Typography variant="body2" color="text.secondary">
            <strong>{t('app.uploadRef')}</strong> {selectedTransRef?.upload_ref}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <strong>{t('app.grandTotal')}</strong>{' '}
            {addCommas(selectedTransRef?.total_pay_amount)}
          </Typography>
         
            <Typography variant="body2" color="text.secondary">
              <strong>{type == 'Approved' && t('app.approvedDate')} </strong>{' '}
              <strong>{type == 'Rejected' && t('app.rejectedDate')} </strong>{' '}
              {dayjs(selectedTransRef?.approveAt).format(
                'YYYY-MM-DD • HH:mm:ss',
              )}
            </Typography>
         
      
        </Box>

        <TextField
          fullWidth
          label={t('app.enterReason')}
          variant="outlined"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          error={touched && !reason.trim()}
          helperText={
            touched && !reason.trim() ? 'กรุณากรอกเหตุผลก่อนทำการ Reverse' : ''
          }
          multiline
          minRows={3}
          sx={{
            backgroundColor: '#fafafa',
            borderRadius: 2,
          }}
        />
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2, justifyContent: 'flex-end' }}>
        <Button
          onClick={onClose}
          variant="outlined"
          color="error"
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            px: 3,
            fontWeight: 500,
          }}
        >
          {t('app.cancel')}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          startIcon={<UndoIcon />}
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            px: 3,
            fontWeight: 500,
            ml: 1,
            boxShadow: 2,
            color: '#fff',
          }}
        >
         {t('app.reverse')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ReverseDialog;
